<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>邀约与征稿</el-breadcrumb-item>
          <el-breadcrumb-item>征稿活动管理</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div v-if="!isDraft"
         class="main">
      <div class="head">
        <h4>征稿活动管理<span style="color: rgb(24, 94, 211);font-size:12px;margin-left:15px;cursor: pointer;"
                v-if="powersObj.manageAllPictureActivity"
                :style="{'color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                @click="seeAll">{{isAllFlag}}</span></h4>
        <p @click="openDialog" :style="{'color': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">+发布活动</p>
      </div>

      <div class="search">
          <!-- 征稿活动 -->
          <p style="margin:0 15px;width:100px;">活动标题:</p>
          <!-- 征稿活动 -->
          <el-input v-model="actForm.name" clearable placeholder="请输入活动标题"></el-input>

          <el-button @click="searchClick"
                   :style="{'margin':'0 15px','backgroundColor': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}"
                   class="btn">搜索</el-button>
        </div>

      <div class="tablebg"
           v-loading="isRefresh">

        



        <div style="width:100%;margin:0 auto;">
          <draftactivitymanagetable :tableData="pictureActivityList"
                                    @authClick="authClick"
                                    @changeClick="changeClick"
                                    @delectClick="delectClick"></draftactivitymanagetable>
        </div>

        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total"></el-pagination>
        </div>
      </div>
    </div>

    <div v-if="isDraft"
         class="main">
      <div class="head">
        <h4>{{draftactivityName}}</h4>
      </div>
      <div class="tablebg">
        <div style="width:calc(100% - 300px);margin:0 auto;padding:20px;">
          <adddraftactivityform :ruleForm ="ruleForm"
                                @updataForm="updataForm"
                                :draftactivityName="draftactivityName"
                                @closeForm="closeForm"
                                @submitForm="submitForm"></adddraftactivityform>
          <!-- <el-button @click="dialogFormVisible = true">弹框表单</el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  draftactivitymanagetable,
  adddraftactivityform
} from "@/components/index";
import { powersObj } from "@/constants/powers";

import { mapGetters } from "vuex";

import { getDate, formatConversion } from "@/plugins/getdate";
import {
  listPictureActivity,
  updatePictureActivity,
  addPictureActivity,
  getPictureActivity,
  deletePictureActivity
} from "@/api/pictureActivity";
import { getUser } from "@/api/user";
export default {
  components: {
    draftactivitymanagetable: draftactivitymanagetable,
    adddraftactivityform: adddraftactivityform
  },
  computed: {
    ...mapGetters(["createUid"])
  },
  data () {
    return {
      //检索
      actForm:{
        name:''
      },


      //权限
      powersObj,

      draftactivityName:'创建征稿活动',

      ruleForm: {
        title: "",
        postLimit: 1,
        articleLimit: 1,
        startAt: "",
        endAt: "",
        fillListArray: [],
        mode: "",
        desc: "",
        theme: "",
        themePicture: "",
        themePictureMobile: "",
        status: 0,

        requiredContent: '0',
        requiredDesc: '1',
        postRole: 'default',
        activityType :'picture',

        createUid: this.createUid
      },

      pictureActivityList: [],

      isDraft: false,
      isRefresh: false,

      total: 0,
      currentPage: 1,
      pageSize: 10,


      //所有
      isAll: 0,
      isAllFlag: '查看所有'
    };
  },
  methods: {

    searchClick(){
      this.currentPage = 1;
      let data
      data = { keyword:this.actForm.name,page: (this.currentPage - 1), pageSize: this.pageSize, createUid: this.isAll }

      // console.log(data)
      this.listPictureActivityAsync(data);
    },
    seeAll () {
      if (this.isAll === 0) {
        this.isAllFlag = '查看个人'
        this.isAll = -1
        this.handleCurrentChange(1)
      } else {
        this.isAllFlag = '查看所有'
        this.isAll = 0
        this.handleCurrentChange(1)
      }
    },

    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      let data
      data = { keyword:this.actForm.name,page: (this.currentPage - 1), pageSize: this.pageSize, createUid: this.isAll }

      // console.log(data)
      this.listPictureActivityAsync(data);
    },

    //刷新表格
    refresh () {
      this.actForm.name = ''
      this.isRefresh = true;
      this.handleCurrentChange(this.currentPage);
      setTimeout(() => {
        this.isRefresh = false;
      }, 888);
    },
    openDialog () {
      this.draftactivityName='创建征稿活动'
      this.isDraft = !this.isDraft;
      this.ruleForm = {
        title: "",
        postLimit: 0,
        articleLimit: 0,
        startAt: "",
        endAt: "",
        fillListArray: [],
        mode: "",
        desc: "",
        theme: "",
        themePicture: "",
        themePictureMobile: "",
        requiredContent: '0',
        requiredDesc: '0',
        activityType :'picture',
        postRole: 'default',
        status: 0,
        createUid: this.createUid
      };
    },
    closeForm () {
      this.isDraft = !this.isDraft;
    },
    submitForm (data) {
      // console.log(data)
      if(this.draftactivityName == '创建征稿活动'){
        this.addPictureActivityAsync(data);
      }else{
        this.updatePictureActivityAsync(data);
      }
      
    },
    updataForm (data) {
      // console.log(data)

      this.updatePictureActivityAsync(data);
    },
    changeClick (data) {
      this.draftactivityName='修改征稿活动'
      this.getPictureActivityAsync(data.row.id);
    },
    authClick (data) {
      this.$confirm("确认修改状态吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          if (data.row.status === 0) {
            data.row.status = 1;
          } else {
            data.row.status = 0;
          }
          this.updatePictureActivityAsync(data.row);
        })
        .catch(() => { });
    },

    delectClick (data) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          this.deletePictureActivityAsync(data.row.id);
        })
        .catch(() => { });
    },

    //删除图片邀约
    async deletePictureActivityAsync (val) {
      let { status, data, message, errors } = await deletePictureActivity(val);
      if (status) {
        this.$message.success("删除成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //查询征稿活动
    async getPictureActivityAsync (val) {
      let { status, data, message, errors } = await getPictureActivity(val);
      if (status) {
        // console.log(data);
        data.fillListArray = data.fillList.split(",");
        this.ruleForm = data;
        this.ruleForm.requiredContent = String(this.ruleForm.requiredContent)
        this.ruleForm.requiredDesc = String(this.ruleForm.requiredDesc)
        console.log(this.ruleForm)
        
        this.isDraft = !this.isDraft;
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //增加征稿活动
    async addPictureActivityAsync (val) {
      let { status, data, message, errors } = await addPictureActivity(val);
      if (status) {
        this.$message.success("添加成功！");
        this.isDraft = false
        this.handleCurrentChange(1);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key] + ','
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //修改征稿活动信息
    async updatePictureActivityAsync (val) {
      let { status, data, message, errors } = await updatePictureActivity(val);
      if (status) {
        this.$message.success("修改成功！");
        this.isDraft = false
        this.handleCurrentChange(this.currentPage);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取征稿活动列表
    async listPictureActivityAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listPictureActivity(
        val
      );
      if (status) {
        this.total = pagination.total;
        for (let i = 0; i < data.length; i++) {
          if (data[i].createUid || data[i].createUid !== 0) {
            var userInfo = await getUser(data[i].createUid);
            data[i].createName = userInfo.data.name;
          } else {
            data[i].createName = '暂无'
          }
          if (data[i].createAt || data[i].createAt !== 0) {
            data[i].createAtMY = formatConversion(data[i].createAt.toString());
          } else {
            data[i].createAtMY = '暂无'
          }
        }
        this.pictureActivityList = data;

        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    }
  },
  created () {
    this.handleCurrentChange(this.currentPage);
    this.timeInt = setInterval(() => {
      this.handleCurrentChange(this.currentPage);
    }, 90000);
  },
  beforeDestroy () {
    // 组件销毁前调用
    clearTimeout(this.timeInt);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./draftactivitymanage.scss";

h4 {
  font-size: 18px;
}
</style>
